import React from "react";

import { Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { FootfallMeasureType } from "modules/customer/tools/location/footfallNew/footfallMeasureType";
import {
    selectLatestMonthFootfall,
    selectAverageDailyFootfallMeasure
} from "modules/customer/tools/location/footfallNew/footfallSlice";

const AverageDailyFootfallText: React.FC = () => {
    const measure = useAppSelector(selectAverageDailyFootfallMeasure);
    const latestMonthFootfall = useAppSelector(selectLatestMonthFootfall);
    const text = measure === FootfallMeasureType.NumberOfVisits
        ? `Average hourly visits per cell within the selected retail centre (${latestMonthFootfall.latestMonthDate.monthLong} ${latestMonthFootfall.latestMonthDate.year})`
        : `Average hourly dwell time per cell within the selected retail centre (${latestMonthFootfall.latestMonthDate.monthLong} ${latestMonthFootfall.latestMonthDate.year})`;
    return (
        <Typography variant="subtitle1" component="div" gutterBottom>
            {text}
        </Typography>
    );
};

export default AverageDailyFootfallText;
